import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AuthModal, DragDropModal, EditorModal } from 'components/Modals'
import AlertBar from './components/AlertBar'
import CreditAddOn from './components/CreditAddOn'
import { useRouter } from 'next/router'
import { toggleAuthModal } from 'store/actions/header.action'
import Header from './Header'
import MobileHeader from './MobileHeader'
import HeaderSkeleton from './components/HeaderSkeleton'
import MobileHeaderSkeleton from './components/MobileHeaderSkeleton'

const HeaderWrapper = ({ displayLeftMenu, isMobile }) => {
  const router = useRouter()
  const { modalType, input, inputType, tags, mediaUrl, ...remainingQueries } = router.query
  const dispatch = useDispatch()
  const { enableAddonModal, enableAuthModal } = useSelector((state) => state.header)
  const { user, authInitialized } = useSelector((state) => state.auth)

  const closeModal = () => {
    router.replace({ pathname: router.pathname, query: remainingQueries }, undefined, {
      shallow: true,
    })
  }

  const isChatPage = useMemo(() => router.pathname === '/chat', [router.pathname])

  return (
    <>
      <AlertBar />

      <div className={`  w-full    ${isChatPage && isMobile ? 'fixed top-0 ' : 'sticky top-0 z-[998]'}`}>
        {enableAddonModal && <CreditAddOn user={user} />}
        {enableAuthModal && <AuthModal onClose={() => dispatch(toggleAuthModal(false))} type={enableAuthModal} />}
        {modalType === 'editor' && (
          <EditorModal
            onClose={() => closeModal()}
            generate={input}
            defaultSelectedModel={inputType}
            tags={tags}
            selectedMedia={mediaUrl}
          />
        )}
        {modalType === 'upload' && <DragDropModal onClose={() => closeModal()} />}

        {!isMobile ? (
          <Header displayLeftMenu={displayLeftMenu} />
        ) : !authInitialized ? (
          <MobileHeaderSkeleton />
        ) : (
          <MobileHeader />
        )}
      </div>
    </>
  )
}

export default HeaderWrapper
